module.exports = __webpack_public_path__ + "img/login_pass.2c5d04be.svg";